export default {
  operator: {},
  operatorsList: [],
};
